import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { EXPORT_TYPES } from '@Services/ExportService/ExportConstants';

import './ExportTabTooltipHeader.scss';

function ExportTabTooltipHeader(props) {
  const { exportType, close } = props;

  return (
    <div className="exportTab__tooltip_header">
      <h4 className="u-els-font-size-h3 u-els-line-height-single u-els-margin-bottom-1o4">
        {exportType === EXPORT_TYPES.CHEMQUOTE ? 'ChemQuote Exports' : 'Exports'}
      </h4>
      <ButtonWithIcon
        data-e2e="export-tab-tooltip-close-button"
        type="link"
        size="small"
        sprite="Close"
        linkIconSize="xs"
        iconOnly
        onClick={close}
        className="close-btn e2e-export-tab-tooltip-button">
        Close
      </ButtonWithIcon>
    </div>
  );
}

ExportTabTooltipHeader.propTypes = {
  exportType: PropTypes.string,
  close: PropTypes.func.isRequired,
};

export default ExportTabTooltipHeader;
